import auth from './auth'
import settings from './settings'
import email from './email'
import phone from './phone'
import quick from './quick'
import wire from './wire'

let mocks = {}

/* if (process.env.NODE_ENV == 'development') { */
    Object.assign(mocks, settings, email, mocks, auth, phone, quick, wire)
/* } */

export default mocks